import Vue from 'vue'
import Router from 'vue-router'
import Event from '@/components/login'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Event
    },
    {
      path: '/heards',
      name: 'heards',
      component: () => import('../components/Header/heards.vue')
    },
    {
      path: '/updatapassword',
      name: 'updatapassword',
      component: () => import('../components/updatapassword.vue')
    },
    // {
    //   path: '/quarysaler',
    //   name: 'quarysaler',
    //   component: () => import('../components/quarysaler.vue')
    // },
    // {
    //   path: '/updatapassword',
    //   name: 'updatapassword',
    //   component: () => import('../components/updatapassword.vue')
    // },
    {
      path: '/sidebar',
      name: 'sidebar',
      redirect: {name: '/quarysaler'},
      children:
      [
        {
          path: '/quarysaler',
          name: 'quarysaler',
          component: () => import('../components/quarysaler.vue')
        },
        {
          path: '/financialmanagement',
          name: 'financialmanagement',
          component: () => import('../components/financialmanagement.vue')
        },
        {
          path: '/expenserecorddetails',
          name: 'expenserecorddetails',
          component: () => import('../components/expenserecorddetails.vue')
        },
        {
          path: '/expenditurescorddetails',
          name: 'expenditurescorddetails',
          component: () => import('../components/expenditurescorddetails.vue')
        },
      ],
      component: () => import('../components/sidebar.vue')
    }
  ]
  // scrollBehavior: () => {
  //   history.pushState(null, null, document.URL)
  // }
})



// WEBPACK FOOTER //
// ./src/router/index.js